import React from "react";
import { HOST_URL } from "../../constants";
import "../../css/payPalButtonWrap.css";
import { tempOrdersErrorCodes } from "../../function/errorCodes";

// let PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });

class PayPalButtonWrap extends React.Component {
  componentDidMount() {
    const {
      orderData,
      tempOrderFailByOutOfStock,
      tempOrderFail,
      setStockData,
      fetchMyBag,
      lang,
    } = this.props;
    window.paypal
      .Buttons({
        locale: "en_US",
        style: {
          color: "black",
          shape: "rect",
          label: "paypal",
          layout: "horizontal",
          fundingicons: false,
          size: "responsive",
          tagline: false,
          height: 50,
        },
        // Set up the transaction
        createOrder() {
          //fire GA event
          if (window.dataLayer) {
            window.dataLayer.push({
              event: "place-order",
              "gtm.element": "paypal",
            });
          }

          return fetch(`${HOST_URL}/shopping/v1/compositions/temp-orders`, {
            method: "post",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify(orderData),
            credentials: "include",
          })
            .then(async function (res) {
              //加錯誤驗證碼
              if (res.status == 201) {
                if (window.insider_object && window.Insider) {
                  window.Insider.fns.isFunction(
                    window.Insider.__external.confirmationInterval130496,
                  ) &&
                    clearInterval(
                      window.Insider.__external.confirmationInterval130496,
                    );
                  window.insider_object = {
                    page: {
                      type: "Confirmation",
                    },
                  };
                  window.Insider.__external.confirmationInterval130496 =
                    setInterval(function () {
                      if (
                        (((window.insider_object || {}).page || {}).type ||
                          "") === "Confirmation"
                      ) {
                        window.Insider.eventManager.dispatch(
                          "init-manager:re-initialize",
                        );
                        console.log("INSIDER_PAGE_TYPE_CONFIRMATION");
                        fetch("/INSIDER_PAGE_TYPE_CONFIRMATION");
                        clearInterval(
                          window.Insider.__external.confirmationInterval130496,
                        );
                      }
                    }, 300);
                }
                return res.json();
              } else if (res.status == 400) {
                //POST temp-otders 失敗
                const data = await res.json();
                //失敗 -> 庫存賣完
                if (data.hasOwnProperty("errors")) {
                  data.errors.forEach((element) => {
                    if (
                      tempOrdersErrorCodes.outOfStock.includes(
                        element.errorCode,
                      )
                    ) {
                      // 顯示庫存不足
                      tempOrderFailByOutOfStock();
                      // 重新取得myBag
                      fetchMyBag();
                      // 取得庫存不足的商品資訊
                      const message = JSON.parse(element.message);
                      setStockData(message);
                    } else if (
                      tempOrdersErrorCodes.couponErrors.includes(
                        element.errorCode,
                      )
                    ) {
                      window.logApiErrors(
                        "r",
                        "createOrder",
                        res.status,
                        res.statusText,
                      );
                      tempOrderFail();
                    }
                  });
                } else {
                  window.logApiErrors(
                    "r",
                    "createOrder",
                    res.status,
                    res.statusText,
                  );
                  // 顯示訂單建立失敗
                  //失敗-> 其他errorCode
                  tempOrderFail();
                }
              } else {
                window.logApiErrors(
                  "r",
                  "createOrder",
                  res.status,
                  res.statusText,
                );
                //失敗 -> 建立temp oreder失敗
                tempOrderFail();
              }
            })
            .then(function (data) {
              // return data.paypalId;
              window.ctId = data.ctId;
              return data.paypalId;
            });
        },
        // Finalize the transaction
        onApprove(data) {
          return fetch(`${HOST_URL}/shopping/v1/compositions/orders`, {
            method: "post",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify({
              ...data,
              paypalId: data.orderID,
            }),
            credentials: "include",
          })
            .then(async function (res) {
              if (res.status == 201) {
                return res.json();
              } else if (res.status == 400) {
                const data = await res.json();
                if (data.hasOwnProperty("errors")) {
                  data.errors.forEach((element) => {
                    if (element.errorCode === "E00951") {
                      // 顯示訂單建立失敗
                      tempOrderFail();
                      fetch(`${HOST_URL}/shopping/v1/compositions/orders`, {
                        method: "put",
                        headers: {
                          "content-type": "application/json",
                        },
                        body: JSON.stringify({
                          ctId: window.ctId,
                        }),
                        credentials: "include",
                      });
                    }
                  });
                } else {
                  window.logApiErrors(
                    "r",
                    "onApprove",
                    res.status,
                    res.statusText,
                  );
                  tempOrderFail();
                }
              } else {
                window.logApiErrors(
                  "r",
                  "onApprove",
                  res.status,
                  res.statusText,
                );
                tempOrderFail();
              }
            })
            .then(function (data) {
              const pathLang = lang === "en" ? "en" : "tc";
              window.location = `/eshop-hk/${pathLang}/result?ctId=${data.encodedCtId}`;
            });
        },
        onShippingChange(data, actions) {
          return actions.resolve();
        },
        onError(err) {},
        onCancel: function (data, actions) {
          // Show a cancel page or return to cart
          return fetch(`${HOST_URL}/shopping/v1/compositions/orders`, {
            method: "put",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify({
              ctId: window.ctId,
            }),
            credentials: "include",
          }).then(async function (res) {
            if (!res.ok) {
              window.logApiErrors("r", "onCancel", res.status, res.statusText);
            }
          });
        },
      })
      .render("#payPalButtonWrap");
  }

  render() {
    return <div id="payPalButtonWrap"></div>;
  }
}
export default PayPalButtonWrap;
